import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { SessionQuery } from '../state/session/session.query';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';
import { AppConfigQuery } from '../state/app-config/app-config.query';
import { UiQuery } from '../../shared/state/ui/ui.query';
import { ToastService } from '../../shared/services/toast/toast.service';

@Injectable({
    providedIn: 'root'
})
export class RoleGuard implements CanActivate {
    constructor(
        private session: SessionQuery,
        private appConfig: AppConfigQuery,
        private _router: Router,
        private _ui: UiQuery,
        private _toast: ToastService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.appConfig.get().useLatestKeycloakFlow) return true;
        return this.session.activeUserRoles$.pipe(
            map(
                (authorities) =>
                    authorities
                        .filter((authority) => authority.includes('ROLE_'))
                        .map((authority) => authority.replace('ROLE_', ''))
                        .some((r) => route.routeConfig.data?.roles?.indexOf(r) >= 0) ||
                    this._router.createUrlTree([this._ui.startPage], {
                        queryParams: { reason: 'unauthorized' }
                    })
            ),
            distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
            tap((isAuthorized) => {
                if (isAuthorized && typeof isAuthorized !== 'boolean') {
                    this._toast.show({
                        intent: 'info',
                        title: 'Switched user?',
                        message: `You got redirected because the new user lacks permission to view the page that was being displayed.`,
                        duration: 8000
                    });
                }
            })
        );
    }
}
